// @flow
import React from 'react';
import Link from 'next/link';
import { FelaComponent, } from 'react-fela';
import { parseStyleProps, } from '@haaretz/htz-css-tools';

import type { Node, } from 'react';
import type { Asset, } from '@haaretz/htz-components';

type Props = {
  assets: Array<Asset>,
  miscStyles?: ?Object,
};

const RelatedAssets = ({ assets, miscStyles, }: Props): Node => (
  <FelaComponent
    style={({ theme, }) => ({
      ...theme.type(-2),
      ':before': {
        content: '"ני\\"ע קשורים"',
        marginEnd: '1rem',
        fontWeight: '700',
      },
      extend: [
        theme.mq(
          { until: 'l', },
          { textAlign: 'center', }
        ),
        ...(miscStyles ? parseStyleProps(miscStyles, theme.mq, theme.type) : []),
      ],
    })}
    as="ul"
  >
    {assets.map(({ name, id, type, }: Asset) => (
      <FelaComponent
        key={id}
        style={{
          display: 'inline-block',
          marginEnd: '1rem',
          textDecoration: 'underline',
          ':not(:last-child)': {
            ':after': {
              content: '","',
            },
          },
        }}
        as="li"
      >
        <Link
          href={{
            pathname: `/asset/${type}`,
            query: {
              assetId: id,
              section: type,
            },
          }}
          as={`/${type}/${id}`}
        >
          <a>{name}</a>
        </Link>
      </FelaComponent>
    ))}
  </FelaComponent>
);

RelatedAssets.defaultProps = { miscStyles: null, };
export default RelatedAssets;
